<template>
  <div>
    <div v-if="form.currentApprovalStep">
      Bước duyệt số: {{ form.currentApprovalStep.stepOrder }} <br />
      Tên bước duyệt: {{ form.currentApprovalStep.stepName }} <br />
      <!-- Người duyệt: {{ form.currentApprovalStep.user }} <br />
    Phòng duyệt: {{ form.currentApprovalStep.department }} <br />
    Chức duyệt: {{ form.currentApprovalStep.position }} <br /> -->
    </div>
    <template v-if="canApproval">
      <hr />
      <a-form-item label="Chọn phê duyệt">
        <a-select
          style="width: 100%"
          v-model="approvalData.approvalStatus"
          placeholder="Chọn hành động"
        >
          <a-select-option value="Approved">
            <a-icon type="check-circle" /> Đồng ý duyệt
          </a-select-option>
          <a-select-option value="Rejected">
            <a-icon type="stop" /> Không đồng ý duyệt
          </a-select-option>
          <a-select-option value="Editting">
            <a-icon type="edit" /> Yêu cầu chỉnh sửa
          </a-select-option>
        </a-select>
      </a-form-item>

      <template v-if="approvalData.approvalStatus">
        <a-form-item label="Ý kiến">
          <a-textarea
            placeholder="Vui lòng nhập ý kiến"
            :rows="2"
            v-model="approvalData.approvalNote"
          />
        </a-form-item>
        <hr />
        <a-button
          @click="trinhDuyet"
          :loading="submiting"
          v-if="approvalData.approvalStatus === 'Approved'"
        >
          <a-icon type="check-circle" /> Đồng ý duyệt
        </a-button>
        <a-button
          type="danger"
          @click="trinhDuyet"
          :loading="submiting"
          v-if="approvalData.approvalStatus === 'Rejected'"
        >
          <a-icon type="stop" /> Không đồng ý duyệt
        </a-button>
        <a-button
          @click="trinhDuyet"
          :loading="submiting"
          v-if="approvalData.approvalStatus === 'Editting'"
        >
          <a-icon type="edit" /> Yêu cầu chỉnh sửa
        </a-button>
      </template>
    </template>
  </div>
</template>
<script>
import gql from "graphql-tag";
import { mapMutations } from "vuex";
export default {
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      submiting: false,
      approvalData: {
        approvalStatus: undefined,
        approvalNote: undefined
      }
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth;
    },
    canApproval() {
      const {
        form: { currentApprovers }
      } = this;
      if (currentApprovers) {
        if (currentApprovers.some(e => e.id === this.currentUser.userId)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapMutations({
      updateApproval: "form/updateApproval",
      setForm: "form/setForm"
    }),
    trinhDuyet() {
      this.submiting = true;

      const tranformData = {
        ...this.approvalData,
        createdForm: this.form.id
      };

      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation(
              $createdForm: ID!
              $approvalStatus: String!
              $approvalNote: String
            ) {
              createApprovalStep(
                data: {
                  createdFormId: $createdForm
                  approvalStatus: $approvalStatus
                  approvalNote: $approvalNote
                }
              ) {
                id
                createdForm {
                  id
                  title
                  code
                  description
                  approvalStatus
                  approvalCurrentStep
                  approvalTotalStep
                  createdFormFields {
                    id
                    name
                    code
                    description
                    type
                    value
                    createdAt
                    updatedAt
                  }
                  approvalSteps {
                    id
                    approvalCurrentStep
                    approvalStatus
                    approvalNote
                    createdAt
                    author {
                      username
                      fullname
                      department {
                        name
                      }
                      position {
                        name
                      }
                    }
                  }
                  currentApprovalStep {
                    stepOrder
                    stepName
                    user
                    department
                    position
                  }
                  author {
                    id
                    username
                  }
                  createdAt
                  updatedAt
                }
              }
            }
          `,
          // Parameters
          variables: tranformData
        })
        .then(data => {
          if (
            data.data.createApprovalStep &&
            data.data.createApprovalStep.createdForm
          ) {
            this.setForm(data.data.createApprovalStep.createdForm);
          }
          this.submiting = false;
        })
        .catch(error => {
          // Error
          console.error("Up loi roi", error);
          this.submiting = false;
        });
    }
  }
};
</script>
